import React, { useState, useRef } from 'react';
import ReactPlayer from 'react-player';

const CardVideoPlayer = ({ url, lightImage }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [isReady, setIsReady] = useState(false);

  const handlePlay = () => {
    setIsPlaying(true);
  };

  const handleOnReady = () => {
    setIsPlaying(true);
    setIsReady(true);
  };

  return (
    <div className="relative w-full h-full">
      {!isReady && <img src={lightImage} />}
      {isReady && !isPlaying && (
        <img
          src="/images/icons/play.svg"
          className="absolute z-[20] right-4 bottom-4 cursor-pointer"
          onClick={() => setIsPlaying(true)}
        />
      )}
      {isReady && isPlaying && (
        <img
          src="/images/icons/pause.svg"
          className="absolute z-[20] right-4 bottom-4 cursor-pointer"
          onClick={() => setIsPlaying(false)}
        />
      )}
      <ReactPlayer
        url={url}
        width="100%"
        height="100%"
        playing={isPlaying}
        onPlay={handlePlay}
        loop={true}
        muted
        controls={false}
        onReady={handleOnReady}
        playsinline={true}
        // playIcon={
        //   <img
        //     src={`/images/icons/${isPlaying ? 'play' : 'pause'}.svg`}
        //     className="relative z-[100]"
        //   />
        // }
        // light={true}
      />
    </div>
  );
};

export default CardVideoPlayer;
